import { createSlice } from '@reduxjs/toolkit';
import { LOGOUT } from '../../../utils/constants';
import {
  createInfluencerRequestPasswordBuilder,
  deleteInfluencerRequestAlbumMediaBuilder,
  fetchInfluencerRequestAlbumMediaBuilder,
  getAlbumMediaTagsBuilder,
  getOrCreateIdVerificationTokenBuilder,
  getQuestionnaireBuilder,
  saveGalleryBuilder,
  saveQuestionnaireAnswersBuilder,
  saveVoiceBuilder,
  saveVoiceElevenLabsBuilder,
  saveWritingStyleAnswersBuilder,
  setMediaPricingBuilder,
  testVoiceBuilder,
  testVoiceElevenLabsBuilder,
  updateBasicInfoBuilder,
  updateOnboardingTypeBuilder,
  updateSubscriptionPriceBuilder,
  updateTelegramInfoBuilder,
  uploadAudioBuilder,
  uploadAudioElevenLabsBuilder,
  uploadBundleBuilder,
  uploadHighQualityAudioBuilder,
} from './builder';

const INIT_STATE = {
  questionnaire: [],
  albumMediaTags: [],
  fetchInfluencerRequestAlbumMediaInfo: {
    pending: false,
    data: [],
  },
  showMoreTags: false,
  pending: {
    createInfluencerRequestPassword: false,
    updateBasicInfo: false,
    updateTelegramInfo: false,
    getOrCreateIdVerificationToken: false,
    uploadBundle: false,
    saveGallery: false,
    saveQuestionnaireAnswers: false,
    uploadAudio: false,
    testVoice: false,
    saveVoice: false,
    updateOnboardingType: false,
    updateSubscriptionPrice: false,
    deleteInfluencerRequestAlbumMedia: false,
    uploadHighQualityAudio: false,
    setMediaPricing: false,
    saveWritingStyleAnswers: false,
  },
};

export const influencerRequestSlice = createSlice({
  name: 'influencerRequest',
  initialState: INIT_STATE,
  reducers: {
    setShowMoreTags: (state, { payload }) => {
      state.showMoreTags = payload;
    },
  },
  extraReducers: builder => {
    createInfluencerRequestPasswordBuilder(builder);
    updateBasicInfoBuilder(builder);
    getOrCreateIdVerificationTokenBuilder(builder);
    getQuestionnaireBuilder(builder);
    updateTelegramInfoBuilder(builder);
    getAlbumMediaTagsBuilder(builder);
    uploadBundleBuilder(builder);
    saveGalleryBuilder(builder);
    saveQuestionnaireAnswersBuilder(builder);
    uploadAudioBuilder(builder);
    testVoiceBuilder(builder);
    saveVoiceBuilder(builder);
    updateOnboardingTypeBuilder(builder);
    updateSubscriptionPriceBuilder(builder);
    fetchInfluencerRequestAlbumMediaBuilder(builder);
    deleteInfluencerRequestAlbumMediaBuilder(builder);
    uploadHighQualityAudioBuilder(builder);
    setMediaPricingBuilder(builder);
    saveVoiceElevenLabsBuilder(builder);
    uploadAudioElevenLabsBuilder(builder);
    testVoiceElevenLabsBuilder(builder);
    saveWritingStyleAnswersBuilder(builder);
    builder.addCase(LOGOUT, () => ({ ...INIT_STATE }));
  },
});

export const { setShowMoreTags } = influencerRequestSlice.actions;

export const selectQuestionnaire = state => state.influencerRequestInfo.questionnaire;
export const selectAlbumMediaTags = state => state.influencerRequestInfo.albumMediaTags;
export const selectShowMoreTags = state => state.influencerRequestInfo.showMoreTags;
export const selectFetchInfluencerRequestAlbumMediaInfo = state =>
  state.influencerRequestInfo.fetchInfluencerRequestAlbumMediaInfo;
export const selectInfluencerRequestActionsPending = state => state.influencerRequestInfo.pending;

export default influencerRequestSlice.reducer;
